import { gql } from "@apollo/client";

export const UPDATE_BRAND_STATUS = gql`
  mutation UpdateBrandStatus($params: BrandInput!) {
    updateBrand(params: $params) {
      brandId
      brandKey
      brandName
      brandDisplayName
      brandDescription
      brandLogoUrl
      brandIsActive
      brandCreatedAt
      brandUpdatedAt
      brandDeletedAt
      brandCreatedBy
      brandUpdatedBy
      brandDeletedBy
      brandFeaturesCount
    }
  }
`;
